import request from '@/utils/request'


// 查询发现板块-搜索列表
export function listDiscoverSearch(query) {
  return request({
    url: '/discovery/discover/search/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-搜索分页
export function pageDiscoverSearch(query) {
  return request({
    url: '/discovery/discover/search/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-搜索详细
export function getDiscoverSearch(data) {
  return request({
    url: '/discovery/discover/search/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-搜索
export function addDiscoverSearch(data) {
  return request({
    url: '/discovery/discover/search/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-搜索
export function updateDiscoverSearch(data) {
  return request({
    url: '/discovery/discover/search/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-搜索
export function delDiscoverSearch(data) {
  return request({
    url: '/discovery/discover/search/delete',
    method: 'post',
    data: data
  })
}
